// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const krookodile: PokeData = {
  "id": 553,
  "name": "krookodile",
  "height": 15,
  "weight": 963,
  "base_experience": 234,
  "types": [
    PokeType.GROUND,
    PokeType.DARK
  ],
  "api_moves": [
    "sand-attack",
    "thrash",
    "leer",
    "bite",
    "earthquake",
    "dig",
    "rage",
    "scary-face",
    "mud-slap",
    "outrage",
    "sandstorm",
    "swagger",
    "crunch",
    "torment",
    "sand-tomb",
    "assurance",
    "embargo",
    "hone-claws",
    "foul-play",
    "power-trip"
  ],
  "moves": [
    "leer",
    "bite",
    "earthquake",
    "scary-face",
    "mud-slap",
    "outrage",
    "sandstorm",
    "crunch",
    "flatter",
    "earth-power",
    "mud-shot",
    "night-daze",
    "rototiller"
  ],
  "evolution_chain": {
    "id": 281,
    "item": null,
    "species": [
      {
        "name": "sandile",
        "order": 552,
        "types": [
          PokeType.GROUND,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "krokorok",
        "order": 553,
        "types": [
          PokeType.GROUND,
          PokeType.DARK
        ],
        "evolves_from_species_id": 551,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 29,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "krookodile",
        "order": 554,
        "types": [
          PokeType.GROUND,
          PokeType.DARK
        ],
        "evolves_from_species_id": 552,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 116,
    "speed": 125,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
